import type { Button } from '@cocoonspace/ui/components/button'
import type { ComponentProps } from 'react'

import { PaymentMethodsList } from '../organisms/payment-methods-list'
import { FormAddNewCard } from './form-add-new-card'

export const PaymentMethodsManager = ({
	addFormButtonVariant,
	onPaymentMethodAdded,
	onDefaultPaymentMethodUpdated,
}: {
	onPaymentMethodAdded?: VoidFunction
	onDefaultPaymentMethodUpdated?: VoidFunction
	addFormButtonVariant?: ComponentProps<typeof Button>['variant']
}) => {
	return (
		<div className='flex flex-col gap-8 md:flex-row'>
			<PaymentMethodsList onSetDefault={onDefaultPaymentMethodUpdated} />

			<div className='md:w-[500px]'>
				<FormAddNewCard
					addFormButtonVariant={addFormButtonVariant}
					onSubmitSuccess={onPaymentMethodAdded}
				/>
			</div>
		</div>
	)
}
